// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 21/08/2025
import { makeApiCall, makeFormApiCall } from '../../../_common/api.utils';
import { FIN_API_URL } from '../../../const';

/*********  GET PROFIT LOSS REPORT  - START  *********/
export const profitLossReportList = (addData: any) => {
	const data = {
		GetProfitLossReportToken: addData,
	};
	const url = `${FIN_API_URL}getProfitLossReport`;
	return makeApiCall(url, data);
};
/*********  GET PROFIT LOSS REPORT  - END  *********/

/********* GET BALANCE SHEET REPORT - START  *********/
export const balancesheetReportList = (updateData: any) => {
	const data = {
		GetBalanceReportToken: updateData,
	};
	const url = `${FIN_API_URL}getBalanceSheetReport`;
	return makeApiCall(url, data);
};
/********* GET BALANCE SHEET REPORT - END  *********/
